import React, { useEffect } from 'react';
import { useAppDispatch } from '@redux/store';
import { loginWithMSToken } from '@services/ApiService';
import { Loading } from '@components/Misc';
import { globalActions } from '@redux/slices/states/global/globalSlice';
import axios from 'axios';
import Config from '@gral/config.json';
import * as Sentry from '@sentry/react';
import { safeStringify } from '@services/utils/ApiErrors';
import { useLocation, useNavigate } from 'react-router';

interface CallbackProps {}
var last_token = null;
const CallbackPage = (props: CallbackProps) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const parseHash = (hash: any) => {
    return hash
      .substring(1)
      .split('&')
      .map((v: any) => v.split('='))
      .reduce((acc: Record<string, string>, [key, value]: [string, any]) => {
        acc[decodeURIComponent(key)] = decodeURIComponent(value);
        return acc;
      }, {});
  };

  const params = parseHash(location.search);

  const loadUserFromSSO = async access_token => {
    const request = await loginWithMSToken(dispatch, access_token);
    const user = request?.payload?.data;
    if (user) {
      dispatch(globalActions.loginSuccess(user));
    } else {
      navigate('/login');
    }
  };

  const getAccessToken = async (code: string) => {
    let body = { ...Config.secondSSO };
    body.code = code;
    body.redirect_uri = window.location.origin + Config.SSO.redirectUri;

    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };

    try {
      const response = await axios.post('https://login.microsoftonline.com/organizations/oauth2/v2.0/token', body, config);

      if (response.data?.access_token) {
        loadUserFromSSO(response.data.access_token);
      }
    } catch (error) {
      dispatch(globalActions.notification('callbackErrorServer'));
      navigate('/login');
    }
  };

  //console.log('Access Token:', params.access_token);
  //console.log('Token Type:', params.token_type);
  //console.log('Expires In:', params.expires_in);
  //console.log('Scope:', params.scope);
  //console.log('Session State:', params.session_state);

  useEffect(() => {
    if (last_token !== params.code) {
      last_token = params.code;
      getAccessToken(params.code);
    }
  }, []);

  return <Loading withoutHeight />;
};

export default CallbackPage;
